module.exports = __webpack_public_path__ + "static_pc/img/2.1a526d7f.png";